





















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getBaseInfo } from './api/index';
import NewsList from './components/NewsList.vue';
import { isWeiXin } from '@/common/ts/common';
import {
  getNow,
  getLive,
  getBoutique,
  getAreaBoutique,
  getCarrying,
} from './api';
import { isMobile } from '@/common/ts/common';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);
@Component({
  components: {
    NewsList,
  },
})
export default class First extends Vue {
  page = 1;
  List = [
    { type: '1', text: '最新资讯' },
    { type: '2', text: '区长县长双晒直播' },
    { type: '3', text: '文旅精品90秒' },
    { type: '4', text: '区县文旅精品荟' },
    { type: '5', text: '区长县长晒精品' },
    { type: '6', text: '云上文旅馆' },
  ];
  getLiveList: any[] = [];
  getNowList: any[] = [];
  getBoutiqueList: any[] = [];
  getAreaBoutiqueList: any[] = [];
  getCarryingList: any[] = [];
  showGetLiveMore = false;
  showGetNow = false;
  showGetBoutique = false;
  showGetAreaBoutique = false;
  showCarrying = false;
  activeBtn = 0;
  getCommitteeListHeight = '';
  offsetHeight = 0;
  offsetTop = 0;
  headerFixed = false;
  isPc = false;
  created() {
    if (!isMobile()) {
      console.log('is pc platform');
      this.isPc = true;
    }
    getNow({ page: this.page }).then((res: any) => this.endNowData(res));
    getLive({ page: this.page }).then((res: any) => this.endLiveData(res));
    getBoutique({ page: this.page }).then((res: any) =>
      this.endBoutiqueData(res),
    );
    getAreaBoutique({ page: this.page }).then((res: any) =>
      this.endAreaBoutiqueData(res),
    );
    getCarrying({ page: this.page }).then((res: any) =>
      this.endCarryingData(res),
    );
  }
  endNowData(res: any) {
    this.getNowList = res.data.slice(0, 4);
    setTimeout(() => {
      this.showGetNow = true;
    }, 150);
  }
  endLiveData(res: any) {
    this.getLiveList = res.data.slice(0, 4);
    setTimeout(() => {
      this.showGetLiveMore = true;
    }, 150);
  }
  endBoutiqueData(res: any) {
    this.getBoutiqueList = res.data.slice(0, 4);
    setTimeout(() => {
      this.showGetBoutique = true;
    }, 150);
  }
  endAreaBoutiqueData(res: any) {
    this.getAreaBoutiqueList = res.data.slice(0, 4);
    setTimeout(() => {
      this.showGetAreaBoutique = true;
    }, 150);
  }
  endCarryingData(res: any) {
    this.getCarryingList = res.data.slice(0, 4);
    setTimeout(() => {
      this.showCarrying = true;
    }, 150);
  }
  handleScroll() {
    // 得到页面滚动的距离
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.offsetHeight = (this.$refs.fixedHeaderRoot as Vue & {
      offsetHeight: number;
    }).offsetHeight;
    // 这里要得到top的距离和元素自身的高度
    this.offsetTop = (this.$refs.fixedHeaderRoot as Vue & {
      offsetTop: number;
    }).offsetTop;
    // 判断页面滚动的距离是否大于吸顶元素的位置
    // this.headerFixed = scrollTop > this.offsetTop - this.offsetHeight;
    if (scrollTop > 204) {
      this.headerFixed = true;
    } else {
      this.headerFixed = false;
    }
  }
  // 锚点跳转
  goAnchor(selector: any, index: number) {
    // console.log(
    //   '????',
    //   this.$el.querySelector(selector).offsetTop,
    //   document.documentElement.scrollTop,
    // );
    this.activeBtn = index;
    // 云上文旅馆跳转链接
    if (index === 5) {
      if (isWeiXin() || !window.udid) {
        console.log('进入页面');
        window.location.href = 'https://tcq-web.1000fun.com/double-show/home';
      }
      {
        const appNavOption = {
          dt: 7,
          url: 'https://tcq-web.1000fun.com/double-show/home',
        };
        if (window.handleMessage) {
          window.handleMessage(
            JSON.stringify({
              action: 'mJump',
              data: JSON.stringify(appNavOption),
            }),
          );
        }
      }
    } else {
      // const top = document.documentElement.scrollTop||document.body.scrollTop;
      document.body.scrollTop = this.$el.querySelector(selector).offsetTop;
      document.documentElement.scrollTop = this.$el.querySelector(
        selector,
      ).offsetTop;
    }
  }
  enterMore(e: any) {
    if (isWeiXin() || !window.udid) {
      console.log('进入页面');
      this.$router.push({
        path: '/20200609SSZT/ListPage',
        query: { type: e },
      });
    } else {
      const appNavOption = {
        dt: 7,
        url: `https://activity.cqcb.com/shangyou_activity/2020q2/20200609SSZT/ListPage?type=${e}`,
      };
      if (window.handleMessage) {
        window.handleMessage(
          JSON.stringify({
            action: 'mJump',
            data: JSON.stringify(appNavOption),
          }),
        );
      }
    }
  }
  enterLink() {
    window.location.href =
      'https://activity.cqcb.com/shangyou_activity/2020q2/20200710SSHD/First';
  }
}
